import Form from '../../../../../../components/form';
import request from '../../../../../../utils/request';
import ModalList from './components/modal_list.vue';
import configProducts from './components/configProducts.vue';
import configOrgs from './components/configOrgs.vue';
import configBudgets from './components/configBudgets.vue';
import configRewards from './components/configRewards.vue';
import tjrConfigInfos from './components/tjrConfigInfos.vue';
import gdConfigInfos from './components/gdConfigInfos.vue';
import cdConfigInfos from './components/cdConfigInfos.vue';
import xfmzConfigInfos from './components/xfmzConfigInfos.vue';

formCreate.component('ModalList', ModalList);
formCreate.component('configProducts', configProducts);
formCreate.component('configOrgs', configOrgs);
formCreate.component('configBudgets', configBudgets);
formCreate.component('configRewards', configRewards);
formCreate.component('tjrConfigInfos', tjrConfigInfos);
formCreate.component('gdConfigInfos', gdConfigInfos);
formCreate.component('cdConfigInfos', cdConfigInfos);
formCreate.component('xfmzConfigInfosCom', xfmzConfigInfos);
export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formFunctionCode: 'banquet_reward_config_form',
    };
  },
  methods: {

    // 设置rule
    setRule(item) {
      const v = item;
      if (v.field === 'productLevelName') { // 选择产品系列
        v.props = {
          ...v.props,
          params: {
            functionCode: 'product_level_list',
          },
          getValue: (field) => this.getFieldValue(field),
          title: v.title,
        };
      }
      if (v.field === 'datePicker') { // 活动规则时间
        v.props = {
          ...v.props,
          type: 'daterange',
          rangeSeparator: '至',
          startPlaceholder: '开始日期',
          endPlaceholder: '结束日期',
          unlinkPanels: true,
          align: 'right',
          valueFormat: 'yyyy-MM-dd',
        };
      }
      if (v.field === 'scanBefore') { // 扫码计算时间，前
        v.props = {
          ...v.props,
          min: 0,
          precision: 0,
          controls: false,
        };
      }
      if (v.field === 'scanAfter') { // 扫码计算时间，后
        v.props = {
          ...v.props,
          min: 0,
          precision: 0,
          controls: false,
        };
      }
      if (v.field === 'executeAddrNum') { // 执行地点个数
        v.props = {
          ...v.props,
          min: 0,
          precision: 0,
          controls: false,
        };
      }
      if (v.field === 'configProducts') { // 选择产品系列
        v.props = {
          ...v.props,
          getValue: (field) => this.getFieldValue(field),
          title: v.title,
        };
      }
      if (v.field === 'configOrgs') {
        v.props = {
          ...v.props,
          params: {
            functionCode: 'business_organization_list',
            paramData: {
              orgType: 'area',
              enableStatus: '009',
            },
          },
          getValue: (field) => this.getFieldValue(field),
          title: v.title,
          autosize: { minRows: 1, maxRows: 6 },
        };
        v.on = {
          ...v.on,
          change: (e) => {
            const arr = [...e];
            const orgVos = [];
            arr.forEach((m) => {
              orgVos.push({
                orgName: m.orgName,
                orgCode: m.orgCode,
              });
            });
            this.setValue({
              configOrgs: orgVos || [],
            });
          },
        };
      }
      if (v.field === 'configFiles') {
        v.props = {
          ...v.props,
          fileMsg: '请上传: pdf,docx,xlsx,ppt,png,jpg等类型，且不超过100M',
        };
      }
      if (v.field === 'openThreshold') { // 开瓶阈值(%)
        v.props = {
          ...v.props,
          min: 0,
          precision: 2,
          controls: false,
        };
      }
      if (v.field === 'openDistance') { // 开瓶距离（m）
        v.props = {
          ...v.props,
          min: 0,
          precision: 2,
          controls: false,
        };
      }
      return v;
    },
    // 表单渲染完成后回调
    formComplete() {
      const productLevelName = this.getRule('productLevelName');
      // 产品系列
      productLevelName.on.change = (e) => {
        if (e && e.length > 0) {
          this.setValue({
            productLevelName: e[0].productLevelName,
            productLevelCode: e[0].productLevelCode,
          });
        } else {
          this.setValue({
            productLevelName: null,
            productLevelCode: null,
          });
        }
      };
      if (this.formConfig.code === 'edit' || this.formConfig.code === 'view') {
        request
          .post('/cps/v1/banquetConfig/findById', {
            id: this.formConfig.row.id,
          })
          .then((res) => {
            if (res.success) {
              const { result } = res;
              result.datePicker = [result.configStartTime, result.configEndTime];
              this.setValue({
                ...result,
                xfmzConfigInfosCom: {
                  tierType: Number(result.tierType),
                  dzList: Number(result.tierType) === 1 ? result.xfmzConfigInfos : [],
                  qjList: Number(result.tierType) === 0 ? result.xfmzConfigInfos : [],
                },
              });
            }
          });
      }
    },
    // 提交
    submit() {
      const formData = this.getFormData(); // 获取表单的值
      console.log('formData____', formData);
      if (formData) {
        let url = '/cps/v1/banquetConfig/saveConfig';
        const params = formData;
        params.configStartTime = formData.datePicker && formData.datePicker.length > 0
          ? formData.datePicker[0]
          : null;
        params.configEndTime = formData.datePicker && formData.datePicker.length > 0
          ? formData.datePicker[1]
          : null;
        delete params.datePicker;
        delete params.title1;
        if (formData.xfmzConfigInfosCom) {
          params.tierType = formData.xfmzConfigInfosCom.tierType;
          params.xfmzConfigInfos = formData.xfmzConfigInfosCom.tierType === 1 ? formData.xfmzConfigInfosCom.dzList : formData.xfmzConfigInfosCom.qjList;
        } else {
          params.tierType = null;
          params.xfmzConfigInfos = [];
        }
        if (this.formConfig.code === 'edit') {
          url = '/cps/v1/banquetConfig/updateConfig';
          params.id = this.formConfig.row.id;
        }
        request.post(url, params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
